/* global $ */
export default ['$compile', directive]

function directive($compile) {
  return {
    restrict: 'A',
    require: '?ngModel',
    link: function($scope, element, attrs, ngModel) {
      element.on('mouseenter', () => {
        $(element).tooltip('show')
      })
    },
  }
}
